var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivacypolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.916,
    height: 19.351,
    viewBox: "0 0 15.916 19.351",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16622 16164)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16622 -16164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.817.329V3.777h3.723ZM23.21,4.92a.586.586,0,0,1-.607-.562V0H14.238A2.162,2.162,0,0,0,12,2.073V17.278a2.162,2.162,0,0,0,2.238,2.073h11.44a2.162,2.162,0,0,0,2.238-2.073V4.92Z",
    transform: "translate(-12)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16618.684 -16158.197)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.115,13.02l-2.071,2.635a.742.742,0,0,1-.523.293h-.084a.663.663,0,0,1-.481-.188L18.639,14.63a.757.757,0,0,1,.983-1.15l.732.627,1.589-2.029a.751.751,0,1,1,1.171.941Zm2.05.711c0,3.7-4.141,5.5-4.308,5.584a.752.752,0,0,1-.23.042.889.889,0,0,1-.23-.042c-.167-.084-4.308-1.882-4.308-5.584V10.677a.566.566,0,0,1,.376-.544l3.974-1.359a.518.518,0,0,1,.356,0l3.974,1.359h0a.566.566,0,0,1,.376.544v3.053Z",
    transform: "translate(-16.087 -8.743)",
    fill: "#1f2e3d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.487 3.316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.587,13.649l-2.071,2.635a.742.742,0,0,1-.523.293H20.91a.663.663,0,0,1-.481-.188l-1.318-1.129a.757.757,0,1,1,.983-1.15l.732.627,1.589-2.029a.751.751,0,1,1,1.171.941Z",
    transform: "translate(-18.847 -12.421)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacypolicy);
export default __webpack_public_path__ + "static/media/privacypolicy.3225ac1946bc862912d70a1c0ae9974f.svg";
export { ForwardRef as ReactComponent };